/** @module builtins/Promise */

/* eslint-disable no-extend-native,promise/spec-only */

if (!Promise.prototype.suppress) {
    /**
     * Suppresses all errors up to the point of calling. Equivalent to .catch((x) => undefined).
     * Method will not be overrided if it already exists.
     * @param {Error|Error[]} [errors] - If specified, only these types of errors are suppressed.
     * @returns {Promise} The promise returned after catching and suppressing all errors.
     */
    Object.defineProperty(Promise.prototype, 'suppress', {
        value: function (errors) {
            const handler = err => {
                if (!errors || [errors].flat().some(e => err instanceof e)) {
                    console.info('Suppressed Promise Error (can be ignored):', err);
                } else {
                    return Promise.reject(err);
                }
            };
            return this.catch(handler);
        },
    });
}

/* eslint-enable no-extend-native,promise/spec-only */
